import React from 'react'
import hoc from '@hoc'
import PropTypes from 'prop-types'
import * as utils from '@utils'
import { Select, MenuItem, FormControl, InputLabel } from '@material-ui/core'
import 'antd/dist/antd.css'

/**
 * props => options
 * hidePf => true/false 是否隱藏站台選項, default: false
 * hideAllPlatform => true/false 是否隱藏全部站台選項, default: false
 * hidePfSubPf => true/false 是否隱藏平台選項, default: false
 * showAllSubPlatform => true/false 是否顯示全部平台選項, default: false
 */
class RankingsTypeSelect extends React.Component {
    constructor(props) {
        super(props)
        this.t = (key, options) => {
            return utils.t(key, 'RankingsTypeSelect', options)
        }
    }

    state = {
        typeList: ['Slot', 'Arcade'],
        type: 'All',
        hideAll: false,
    }

    componentDidMount() {
        const hideAll = this.props?.options?.hideAll ?? false
        this.setState({
            hideAll,
        })

        this.props.onRef(this)
    }

    componentWillUnmount() {
        this.props.onRef(undefined)
    }

    render() {
        return (
            <React.Fragment>
                {
                    <FormControl className={this.props.classes.formControl} disabled={this.state.currencyDisabled}>
                        {<InputLabel htmlFor="age-simple">{this.t('rankingsType')}</InputLabel>}
                        <Select
                            value={this.state.type}
                            onChange={(event) => {
                                this.setState({
                                    type: event.target.value,
                                })
                            }}>
                            {!this.state.hideAll && (
                                <MenuItem value={'All'} key={`All`}>
                                    {this.t('Device.all')}
                                </MenuItem>
                            )}
                            {this.state.typeList.map((type) => (
                                <MenuItem value={type} key={`${type}`}>
                                    {type}
                                </MenuItem>
                            ))}
                        </Select>
                    </FormControl>
                }
            </React.Fragment>
        )
    }
}

RankingsTypeSelect.propTypes = {
    classes: PropTypes.objectOf(PropTypes.string),
    onRef: PropTypes.func.isRequired,
    options: PropTypes.object,
    hideAll: PropTypes.bool,
}

const styles = (theme) => {
    return {
        formControl: {
            margin: theme.spacing(1),
            width: '150px',
        },
    }
}

export default hoc(styles)(RankingsTypeSelect)
